/**
 * Currency code normalizer
 * Maps common currency names and codes to ISO 4217 currency codes
 * Supports the 100 most common currencies
 */

const CURRENCY_MAP: Record<string, string> = {
  // Major currencies
  'USD': 'USD',
  'US Dollar': 'USD',
  'Dollar': 'USD',
  'EUR': 'EUR',
  'Euro': 'EUR',
  'GBP': 'GBP',
  'British Pound': 'GBP',
  'Pound': 'GBP',
  'JPY': 'JPY',
  'Japanese Yen': 'JPY',
  'Yen': 'JPY',
  'CNY': 'CNY',
  'Chinese Yuan': 'CNY',
  'Yuan': 'CNY',
  'AUD': 'AUD',
  'Australian Dollar': 'AUD',
  'CAD': 'CAD',
  'Canadian Dollar': 'CAD',
  'CHF': 'CHF',
  'Swiss Franc': 'CHF',
  'HKD': 'HKD',
  'Hong Kong Dollar': 'HKD',
  'NZD': 'NZD',
  'New Zealand Dollar': 'NZD',
  'SEK': 'SEK',
  'Swedish Krona': 'SEK',
  'KRW': 'KRW',
  'South Korean Won': 'KRW',
  'Won': 'KRW',
  'SGD': 'SGD',
  'Singapore Dollar': 'SGD',
  'NOK': 'NOK',
  'Norwegian Krone': 'NOK',
  'MXN': 'MXN',
  'Mexican Peso': 'MXN',
  'Peso': 'MXN',
  'INR': 'INR',
  'Indian Rupee': 'INR',
  'Rupee': 'INR',
  'RUB': 'RUB',
  'Russian Ruble': 'RUB',
  'Ruble': 'RUB',
  'ZAR': 'ZAR',
  'South African Rand': 'ZAR',
  'Rand': 'ZAR',
  'TRY': 'TRY',
  'Turkish Lira': 'TRY',
  'Lira': 'TRY',
  'BRL': 'BRL',
  'Brazilian Real': 'BRL',
  'Real': 'BRL',
  'TWD': 'TWD',
  'Taiwan Dollar': 'TWD',
  'DKK': 'DKK',
  'Danish Krone': 'DKK',
  'PLN': 'PLN',
  'Polish Zloty': 'PLN',
  'Zloty': 'PLN',
  'THB': 'THB',
  'Thai Baht': 'THB',
  'Baht': 'THB',
  'MYR': 'MYR',
  'Malaysian Ringgit': 'MYR',
  'Ringgit': 'MYR',
  'IDR': 'IDR',
  'Indonesian Rupiah': 'IDR',
  'Rupiah': 'IDR',
  'CZK': 'CZK',
  'Czech Koruna': 'CZK',
  'Koruna': 'CZK',
  'HUF': 'HUF',
  'Hungarian Forint': 'HUF',
  'Forint': 'HUF',
  'ILS': 'ILS',
  'Israeli Shekel': 'ILS',
  'Shekel': 'ILS',
  'CLP': 'CLP',
  'Chilean Peso': 'CLP',
  'PHP': 'PHP',
  'Philippine Peso': 'PHP',
  'AED': 'AED',
  'UAE Dirham': 'AED',
  'Dirham': 'AED',
  'SAR': 'SAR',
  'Saudi Riyal': 'SAR',
  'Riyal': 'SAR',
  'ARS': 'ARS',
  'Argentine Peso': 'ARS',
  'BGN': 'BGN',
  'Bulgarian Lev': 'BGN',
  'Lev': 'BGN',
  'RON': 'RON',
  'Romanian Leu': 'RON',
  'Leu': 'RON',
  'HRK': 'HRK',
  'Croatian Kuna': 'HRK',
  'Kuna': 'HRK',
  'EGP': 'EGP',
  'Egyptian Pound': 'EGP',
  'VND': 'VND',
  'Vietnamese Dong': 'VND',
  'Dong': 'VND',
  'PKR': 'PKR',
  'Pakistani Rupee': 'PKR',
  'BDT': 'BDT',
  'Bangladeshi Taka': 'BDT',
  'Taka': 'BDT',
  'NGN': 'NGN',
  'Nigerian Naira': 'NGN',
  'Naira': 'NGN',
  'KES': 'KES',
  'Kenyan Shilling': 'KES',
  'Shilling': 'KES',
  'COP': 'COP',
  'Colombian Peso': 'COP',
  'PEN': 'PEN',
  'Peruvian Sol': 'PEN',
  'Sol': 'PEN',
  'UAH': 'UAH',
  'Ukrainian Hryvnia': 'UAH',
  'Hryvnia': 'UAH',
  'IQD': 'IQD',
  'Iraqi Dinar': 'IQD',
  'Dinar': 'IQD',
  'MAD': 'MAD',
  'Moroccan Dirham': 'MAD',
  'QAR': 'QAR',
  'Qatari Riyal': 'QAR',
  'KWD': 'KWD',
  'Kuwaiti Dinar': 'KWD',
  'BHD': 'BHD',
  'Bahraini Dinar': 'BHD',
  'OMR': 'OMR',
  'Omani Rial': 'OMR',
  'Rial': 'OMR',
  'JOD': 'JOD',
  'Jordanian Dinar': 'JOD',
  'LBP': 'LBP',
  'Lebanese Pound': 'LBP',
  'ISK': 'ISK',
  'Icelandic Krona': 'ISK',
  'RSD': 'RSD',
  'Serbian Dinar': 'RSD',
  'BAM': 'BAM',
  'Bosnian Mark': 'BAM',
  'Mark': 'BAM',
  'MKD': 'MKD',
  'Macedonian Denar': 'MKD',
  'Denar': 'MKD',
  'ALL': 'ALL',
  'Albanian Lek': 'ALL',
  'Lek': 'ALL',
  'MDL': 'MDL',
  'Moldovan Leu': 'MDL',
  'UZS': 'UZS',
  'Uzbekistani Som': 'UZS',
  'Som': 'UZS',
  'KZT': 'KZT',
  'Kazakhstani Tenge': 'KZT',
  'Tenge': 'KZT',
  'AZN': 'AZN',
  'Azerbaijani Manat': 'AZN',
  'Manat': 'AZN',
  'GEL': 'GEL',
  'Georgian Lari': 'GEL',
  'Lari': 'GEL',
  'AMD': 'AMD',
  'Armenian Dram': 'AMD',
  'Dram': 'AMD',
  'BYN': 'BYN',
  'Belarusian Ruble': 'BYN',
  'KGS': 'KGS',
  'Kyrgystani Som': 'KGS',
  'TJS': 'TJS',
  'Tajikistani Somoni': 'TJS',
  'Somoni': 'TJS',
  'TMT': 'TMT',
  'Turkmenistani Manat': 'TMT',
  'MNT': 'MNT',
  'Mongolian Tugrik': 'MNT',
  'Tugrik': 'MNT',
  'AFN': 'AFN',
  'Afghan Afghani': 'AFN',
  'Afghani': 'AFN',
  'IRR': 'IRR',
  'Iranian Rial': 'IRR',
  'LKR': 'LKR',
  'Sri Lankan Rupee': 'LKR',
  'MMK': 'MMK',
  'Myanmar Kyat': 'MMK',
  'Kyat': 'MMK',
  'KHR': 'KHR',
  'Cambodian Riel': 'KHR',
  'Riel': 'KHR',
  'LAK': 'LAK',
  'Laotian Kip': 'LAK',
  'Kip': 'LAK',
  'BND': 'BND',
  'Brunei Dollar': 'BND',
  'XOF': 'XOF',
  'West African CFA Franc': 'XOF',
  'XAF': 'XAF',
  'Central African CFA Franc': 'XAF',
  'ETB': 'ETB',
  'Ethiopian Birr': 'ETB',
  'Birr': 'ETB',
  'GHS': 'GHS',
  'Ghanaian Cedi': 'GHS',
  'Cedi': 'GHS',
  'UGX': 'UGX',
  'Ugandan Shilling': 'UGX',
  'TZS': 'TZS',
  'Tanzanian Shilling': 'TZS',
  'MZN': 'MZN',
  'Mozambican Metical': 'MZN',
  'Metical': 'MZN',
  'AOA': 'AOA',
  'Angolan Kwanza': 'AOA',
  'Kwanza': 'AOA',
  'ZMW': 'ZMW',
  'Zambian Kwacha': 'ZMW',
  'Kwacha': 'ZMW',
  'BWP': 'BWP',
  'Botswana Pula': 'BWP',
  'Pula': 'BWP',
  'NAD': 'NAD',
  'Namibian Dollar': 'NAD',
  'MUR': 'MUR',
  'Mauritian Rupee': 'MUR',
  'LSL': 'LSL',
  'Lesotho Loti': 'LSL',
  'Loti': 'LSL',
  'SZL': 'SZL',
  'Swazi Lilangeni': 'SZL',
  'Lilangeni': 'SZL',
};

/**
 * Normalizes a currency code or name to ISO 4217 format
 * @param currency - Currency code or name (e.g., "Euro", "EUR", "USD")
 * @returns Normalized ISO 4217 currency code, defaults to "USD" if not found
 */
export function normalizeCurrencyCode(currency: string | null | undefined): string {
  if (!currency) {
    return 'USD';
  }

  // Trim and convert to title case for matching
  const normalized = currency.trim();
  
  // Direct match (case-insensitive)
  const upperKey = normalized.toUpperCase();
  if (CURRENCY_MAP[upperKey]) {
    return CURRENCY_MAP[upperKey];
  }

  // Try exact match first
  if (CURRENCY_MAP[normalized]) {
    return CURRENCY_MAP[normalized];
  }

  // Try case-insensitive match
  const lowerKey = normalized.toLowerCase();
  for (const [key, value] of Object.entries(CURRENCY_MAP)) {
    if (key.toLowerCase() === lowerKey) {
      return value;
    }
  }

  // If no match found, return USD as default
  console.warn(`Currency code "${currency}" not found in currency map, defaulting to USD`);
  return 'USD';
}

